<template>
  <v-container>
    <v-card id="loginForm">
      <v-toolbar class="elevation-0" style="background-color: #fff">
        <h1 style="color: blue">Login</h1>
      </v-toolbar>
      <form @submit.prevent="submitForm">
        <v-card-text>
          <v-text-field
            v-model="username"
            name="login"
            label="🏢ユーザーID"
            type="text"
            variant="outlined"
            :rules="usernameRules"
            :error="usernameError !== ''"
            :error-messages="usernameError"
          ></v-text-field>
          <v-text-field
            v-model="password"
            name="password"
            label="🔑パスワード"
            :type="showPassword ? 'text' : 'password'"
            variant="outlined"
            :rules="passwordRules"
            :error="passwordError !== ''"
            :error-messages="passwordError"
            @click:append-inner="toggleShowPassword"
            :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="mx-auto"
            type="submit"
            style="
              width: 95%;
              font-weight: bold;
              background-color: blue;
              color: white;
            "
          >
            ログイン
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { defineComponent } from "vue";
import { mdiEye, mdiEyeOff } from "@mdi/js";

export default defineComponent({
  name: "LoginForm",
  data() {
    return {
      showSidebar: false,
      username: "",
      password: "",
      showPassword: false,
      usernameError: "",
      passwordError: "",
      icons: {
        eye: mdiEye,
        eyeOff: mdiEyeOff,
      },
      usernameRules: [
        (value) => {
          if (value && value?.length > 150) {
            return "150文字以下で記入してください。";
          }
          return true;
        },
      ],
      passwordRules: [
        (value) => {
          if (value && value?.length > 128) {
            return "128文字以下で記入してください。";
          }
          return true;
        },
      ],
    };
  },
  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    submitForm() {
      this.usernameError = "";
      this.passwordError = "";

      if (!this.username) {
        this.usernameError = "ユーザーIDを入力してください。";
      }

      if (!this.password) {
        this.passwordError = "パスワードを入力してください。";
      }
      if (this.username && this.password) {
        this.$emit("onSubmit", {
          username: this.username,
          password: this.password,
        });
      }
    },
  },
});
</script>

<style>
#loginForm {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  margin-top: 15%;
  border: none !important;
  box-shadow: none !important;
}

h1 {
  margin-left: 20px;
  margin-bottom: -10px;
}
</style>
